import { CONFIG } from '../../../config';
import { AccountContext } from '../../../contexts/AccountContext';
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import Dropbox from '../../Dropbox';
import ValueInput from '../../ValueInput';
import Features from './Features';
import Form from 'react-bootstrap/esm/Form';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkReferenceContext, DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * Equipment details component
 */
export default class EquipmentDetails extends WLDInputComponent {

    constructor(props: {band: number, bandItem: string}) {
        super(props);
    }

    /**
     * Function is called when the equipment configuration is changed
     * @param link  user's data
     * @param newData New data which has been selected
     * @param bandItem suffix of the data field
     */
    static onChange(token: string, link: Readonly<any>, newData: any, bandItem: string) {
        var equipConfField = "equipConf"+bandItem;

     //   if(link["edit"] == null && equipConfField != "" && link[equipConfField]?.idConf == newData.idConf) return; // to avoid duplicated requests for the same configuration, except configuration field for the first band

        link.define(equipConfField, newData);

        if(link["equipType2"] != null) { // if we are in dual band
            EquipmentDetails.refreshDualbandAntennas(token, link, "", "2");
        }

        fetch(CONFIG.apiURI+"/references/features/"+link.equipNorms.idEquipNorm+"/"+link["equipType"+bandItem].idEquip+"/"+link["equipFreq"+bandItem].idFreq+"/"+link["equipConf"+bandItem].idConf, { 
            method: 'GET',
            mode: "cors",
            headers: {
                Accept: 'application/json',
                "token": token
            }
            })
        .then((res) => res.json())
        .then((json) => {
            let newEquipConf = link[equipConfField];
            newEquipConf["features"] = json;
            link.define(equipConfField, newEquipConf);
    
            link["features"+bandItem]?.forEach((selectedFeature: any, i: number) => {
                var found = false;
                json.forEach((availableFeature: any, k: number) => {
                    if(selectedFeature == availableFeature.idFeature.toString()) {
                        found = true;
                        return;
                    }
                })
                if(!found) {
                    link["features"+bandItem].splice(i, 1);
                    // We first force CP (1) to AP (2)                
                    // Special change of Vertical (5) to Horizontal (6) in case of 80GHz 2+0 AP
                    // Normally managed at Features component onChangePolar event, but not raisable form Config change here           
                    if(selectedFeature == 1) {
                        link["features"+bandItem].splice(i, 0, "2");
                        link["features"+bandItem].splice(link["features"+bandItem].indexOf("5"),1,"6");
                    }               
                }
            });          
        })
    }

    /**
     * Function is called when the frequency is changed
     * @param token user's token to get the channel bandwidths available for a frequency
     * @param link  user's data
     * @param newData New data which has been selected
     * @param forBandItem suffix of the data field for
     * @param withBandItem suffix of the other data field 
     */
    static onChangeFreq(token: string, link: Readonly<any>, newData: {idFreq:number}, forBandItem: string, withBandItem?: string) {
        var equipFreqField = "equipFreq"+forBandItem

       // if(link.edit && withBandItem == null && link[equipFreqField]?.idFreq == newData.idFreq) return; // to avoid duplicated requests for the same frequency


        link.define(equipFreqField, newData);

        let URL = CONFIG.apiURI+"/references/transmission/"+link.equipNorms.idEquipNorm+"/"+link.equipType.idEquip+"/"+newData.idFreq;

        if(withBandItem != null && link["equipType"+withBandItem] != null && link["equipType"+forBandItem] != null) { // If the function is applied on a band item != "", we can consider it's band == 2 (to avoid to forward a new argument)
            URL = CONFIG.apiURI+"/references/dualband/transmission/"+link.equipNorms.idEquipNorm+"/"+link["equipType"+withBandItem].idEquip+"/"+link.equipNorms.idEquipNorm+"/"+link["equipType"+forBandItem].idEquip+"/"+newData.idFreq;
        }

        fetch(URL, { 
            method: 'GET',
            mode: "cors",
            headers: {
                Accept: 'application/json',
                "token": token
            }
            })
        .then((res) => res.json())
        .then((json) => {
            let newEquipFreq = link[equipFreqField];

            newEquipFreq["bandwidths"] = json["bandwidths"];
            if(link?.equipBandw != null) {
                let foundBdw = false;
                json["bandwidths"].forEach((bdw:any) => {
                    if(bdw.idChannelBdw == link["equipBandw"+forBandItem]?.idChannelBdw) {
                        link.define("equipBandw"+forBandItem, bdw);
                        foundBdw = true;
                        return;
                    }
                });
                if(!foundBdw) {
                    link.define("equipBandw"+forBandItem, json["bandwidths"][0]);                
                }
            }


            newEquipFreq["antennas"] = json["antennas"];
            if(link["equipAntennaSite1"+forBandItem] != null) {
                let foundAntSite1 = false;
                json["antennas"].forEach((ant:any) => {
                    if(ant.label == link["equipAntennaSite1"+forBandItem]?.label) {
                        link.define("equipAntennaSite1"+forBandItem, ant);
                        foundAntSite1 = true;
                        return;
                    }
                });
                if(!foundAntSite1) {
                    link.define("equipAntennaSite1"+forBandItem, json["antennas"][0]);                
                }
            }

            if(link["equipAntennaSite2"+forBandItem] != null) {
                let foundAntSite2 = false;
                json["antennas"].forEach((ant:any) => {
                    if(ant.label == link["equipAntennaSite2"+forBandItem]?.label) {
                        link.define("equipAntennaSite2"+forBandItem, ant);
                        foundAntSite2 = true;
                        return;
                    }
                });
                if(!foundAntSite2) {
                    link.define("equipAntennaSite2"+forBandItem, json["antennas"][0]);                
                }
            }

            if(link["features"+forBandItem]?.includes("4")) {
                if(link["equipAntennaSite1Div"+forBandItem] != null) {
                    let foundAntSite1Div = false;
                    json["antennas"].forEach((ant:any) => {
                        if(ant.label == link["equipAntennaSite1Div"+forBandItem]?.label) {
                            link.define("equipAntennaSite1Div"+forBandItem, ant);
                            foundAntSite1Div = true;
                            return;
                        }
                    });
                    if(!foundAntSite1Div) {
                        link.define("equipAntennaSite1Div"+forBandItem, json["antennas"][0]);                
                    }
                }

                if(link["equipAntennaSite2Div"+forBandItem] != null) {
                    let foundAntSite2Div = false;
                    json["antennas"].forEach((ant:any) => {
                        if(ant.label == link?.equipAntennaSite2Div?.label) {
                            link.define("equipAntennaSite2Div"+forBandItem, ant);
                            foundAntSite2Div = true;
                            return;
                        }
                    });
                    if(!foundAntSite2Div) {
                        link.define("equipAntennaSite2Div"+forBandItem, json["antennas"][0]);                
                    }
                }
            }


            newEquipFreq["configurations"] = json["configurations"];
            if(link["equipConf"+forBandItem] != null) {
                let foundConf = false;
                json["configurations"].forEach((conf:any) => {
                    if(conf.idConf == link["equipConf"+forBandItem].idConf) {
                        link.define("equipConf"+forBandItem, conf);
                        EquipmentDetails.onChange(token, link, conf, forBandItem)
                        foundConf = true;
                        return;
                    }
                });
                if(!foundConf) {
                    link.define("equipConf"+forBandItem, json["configurations"][0]);                
                }
            }
            
            link.define("equipFreq"+forBandItem, newEquipFreq);

            if(withBandItem != undefined) {
                EquipmentDetails.refreshDualbandAntennas(token, link, forBandItem, withBandItem);
            }
        })
    }

    /**
     * Function is called when the channel bandwidth is changed
     * @param token user's token to get the modulations available for a channel bandwidth
     * @param link  user's data
     * @param newData New data which has been selected
     */
    static onChangeChannelBdw(token: string, link: Readonly<any>, newData: {idChannelBdw: number}, bandItem: string) {
        link.define("equipBandw"+bandItem, newData);
        if(newData == null) return;
        EquipmentDetails.refreshModulations(token, link, bandItem);
    }

    /**
     * Get all modulations and TX Powers
     * @param token user's token to get the modulations available for a channel bandwidth
     * @param link  user's data
     * @param bandItem suffix of the data field
     */
    static refreshModulations(token: string, link: Readonly<any>, bandItem: string) {
        
        // if(link["equipType"+bandItem] == null || link["equipFreq"+bandItem] == null || link["equipBandw"+bandItem] == null) return;

        fetch(CONFIG.apiURI+"/references/modulations/"+link.equipNorms.idEquipNorm+"/"+link["equipType"+bandItem].idEquip+"/"+link["equipFreq"+bandItem].idFreq+"/"+link["equipBandw"+bandItem].idChannelBdw, { 
            method: 'GET',
            mode: "cors",
            headers: {
                Accept: 'application/json',
                "token": token
            }
            })
        .then((res) => res.json())
        .then((json) => {
            let newEquipBandw = link["equipBandw"+bandItem];
            newEquipBandw["modulations"] = json;

            if(link["equipMod"+bandItem] != null) {
                let foundMod = false;
                json.forEach((mod:any) => {
                    if(mod.idMod == link["equipMod"+bandItem].idMod) {
                        link.define("equipMod"+bandItem, mod);
                        foundMod = true;
                        return;
                    }
                });
                if(!foundMod) {
                    link.define("equipMod"+bandItem, json[0]);                
                }
            }

            if(link["equipModMax"+bandItem] != null) {
                let foundModMax = false;
                json.forEach((mod:any) => {
                    if(mod.idMod == link["equipModMax"+bandItem]?.idMod) {
                        link.define("equipModMax"+bandItem, mod);
                        foundModMax = true;
                        return;
                    }
                });
                if(!foundModMax) {
                    link.define("equipModMax"+bandItem, json[json.length-1]);                
                }
            }

            link.define("equipBandw"+bandItem, newEquipBandw);
        })
    }

    /**
     * Get the dual band antennas if these ones are available for the selected mix
     * ONLY for the dual band !
     * @param token Account token to access to the WLD API
     * @param link All settings that user has selected 
     * @param bandItem Name of the band item
     * @param bandItem1 Name of the second band item
     */
    static refreshDualbandAntennas(token: string, link: any, bandItem: string, bandItem1: string) {

        if(link["equipType"+bandItem] != null && link["equipType"+bandItem1] != null && link["equipFreq"+bandItem] != null && link["equipFreq"+bandItem1] != null && link["equipConf"+bandItem] != null && link["equipConf"+bandItem1] != null) {
            fetch(CONFIG.apiURI+"/references/dualband/antennas/"
            +link.equipNorms.idEquipNorm+"/"+link["equipType"+bandItem].idEquip+"/"+link["equipFreq"+bandItem].idFreq+"/"+link["equipConf"+bandItem].idConf+"/"
            +link.equipNorms.idEquipNorm+"/"+link["equipType"+bandItem1].idEquip+"/"+link["equipFreq"+bandItem1].idFreq+"/"+link["equipConf"+bandItem1].idConf, { 
                method: 'GET',
                mode: "cors",
                headers: {
                    Accept: 'application/json',
                    "token": token
                }
            })
            .then((res) => res.json())
            .then((json) => {
                if(link.equipDualBandAntenna != null) {
                    var found = false;
                    json.forEach((antenna: any) => {
                        if(antenna.idAntenna == link.equipDualBandAntenna.idAntenna) {
                            found = true;
                            return
                        }
                    });

                    if(!found) {
                        link.define("equipDualBandAntenna", null);
                    }
                }

                if(json.length == 0) {
                    link.define("showDualBandAntenna", false);
                }

                link.define("dualBandAntennas", json);
            })
        } else {
            if(link.equipDualBandAntenna != null) {
                link.define("equipDualBandAntenna", null);
                link.define("showDualBandAntenna", false)
            }
        }
    }

    /**
     * Check if adaptative modulation is mandatory
     * @param link 
     * @returns boolean
     */
    adaptativeModIsMandatory(link: any) {
        for (let i = 0; i < link["equipConf"+this.props.bandItem]?.features?.length; i++) {
            if(link["equipConf"+this.props.bandItem]?.features[i].idFeature == 7 && link["equipConf"+this.props.bandItem]?.features[i].mandatory) {
                return true;
            }
        }
        return false;
    }

    /**
     * Function is called when space diversity is checked
     * @param link Function called when
     * @param newData 
     */
    onChangeSD(link: Readonly<any>, newData: any) {
        let features = link["features"+this.props.bandItem] == undefined ? [] : link["features"+this.props.bandItem];

        if(features.includes(newData.target.value.toString())) {
            features = features.filter((item: any) => ![newData.target.value].includes(item));
        } else {
            features.push(newData.target.value);
        }
        link.define("features"+this.props.bandItem, features);
    }

    /**
     * Function is called when the modulation is changed
     * @param link  user's data
     * @param newData New data which has been selected
     */
    onChangeMod(link: Readonly<any>, newData: {}) {
        link.define("equipMod"+this.props.bandItem, newData);
    }

    /**
     * Function is called when the max modulation is changed
     * @param link  user's data
     * @param newData New data which has been selected
     */
    onChangeModMax(link: Readonly<any>, newData: {}) {
        link.define("equipModMax"+this.props.bandItem, newData);
    }

    /**
     * Remove the values in the data array which are less than the value of the parameter
     * @param value Value which is the minimum value
     * @param data List of the values which will be filtered
     */
    filterLessValue(value: number, data: [{val:number}]) {
        if(!data) return;

        let res = [];
        if(data.length > 0) {
            for (let i = (data.length-1); i >= 0; i--) {
                if(data[i].val >= value) {
                    res.push(data[i])
                }            
            }
        }
        return res
    }

    /**
     * Get the TX Power by idMod and idFreq
     * @param idMod Id of the modulation
     * @param idFreq  Id of the frequency
     * @param refFrequenceMods Array which contains the TxPowers 
     * @returns the TX Power of the modulation and frequency
     */
    getTxPower(idMod: number, idFreq: number, refFrequenceMods: [{idMod: number, idFreq: number, txPower: number}]) {
        for (let i = 0; i < refFrequenceMods.length; i++) {
            const e = refFrequenceMods[i];
            if(e.idMod === idMod && e.idFreq === idFreq) {
                return e.txPower;
            }
        }
        return 0;
    }

    render() {
        return (
            <AccountContext.Consumer>
            {(acc) => (
                <>
                {this.props.band == 1 ?
                <SingleBandLinkUserContext.Consumer>
                {(link) => (
                    <>
                    <SingleBandLinkReferenceContext.Consumer>
                        {(linkRef) => (
                            <>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Label>Frequency band (GHz)</Form.Label>
                                        <Dropbox 
                                            uniqueKey="idFreq" 
                                            displayInputKey="freq"
                                            showStartedKey={link?.edit}
                                            startedKey={link["equipFreq"+this.props.bandItem]?.idFreq}
                                            values={(link["equipType"+this.props.bandItem] != null) ? link["equipType"+this.props.bandItem].frequences : []} 
                                            onChange={(newData) => EquipmentDetails.onChangeFreq(acc.token, link, newData, this.props.bandItem)}
                                        />
                                    </Col>
                                    
                                    <Col xs={6}>
                                        <Form.Label>Channel bandwidth (MHz)</Form.Label>
                                        <Dropbox 
                                            uniqueKey="idChannelBdw" 
                                            displayInputKey="val"
                                            showStartedKey={link?.edit}
                                            startedKey={link["equipBandw"+this.props.bandItem]?.idChannelBdw}
                                            values={(link["equipFreq"+this.props.bandItem] != null) ? link["equipFreq"+this.props.bandItem].bandwidths : []} 
                                            onChange={(newData) => EquipmentDetails.onChangeChannelBdw(acc.token, link, newData, this.props.bandItem)}
                                        />
                                    </Col>
                                    
                                </Row>

                                <Row>
                                    <Col xs={6}>
                                        <Form.Label>Configuration</Form.Label>
                                        <Dropbox 
                                            uniqueKey="idConf" 
                                            displayInputKey="name" 
                                            showStartedKey={link?.edit}
                                            startedKey={link["equipConf"+this.props.bandItem]?.idConf}
                                            values={(link["equipFreq"+this.props.bandItem] != null) ? link["equipFreq"+this.props.bandItem]?.configurations : []} 
                                            onChange={(newData) => EquipmentDetails.onChange(acc.token, link, newData, this.props.bandItem)}
                                        />
                                    </Col>
            
                                    <Col xs={6} style={{marginBottom: "0", marginTop: "auto"}} className='pb-1'>
                                        <SingleBandLinkUserContext.Consumer>
                                            {(linkUser) => (
                                            linkUser["equipConf"+this.props.bandItem]?.features?.map((st: {idFeature: number, name: string, shortname: string, mandatory: boolean}, index: any) =>
                                                <>
                                                { st.idFeature == 4 ?
                                                    <Form.Check 
                                                        type="checkbox"
                                                        label={st.name}
                                                        value={st.idFeature}
                                                        checked={st.mandatory || linkUser?.features?.includes(st.idFeature.toString())} 
                                                        onChange={(e) => {
                                                            if(!st.mandatory) {
                                                                this.onChangeSD(linkUser, e)
                                                            }
                                                        }}
                                                        disabled={st.mandatory}
                                                    />
                                                : <></> }
                                                </>
                                                )
                                            )}
                                        </SingleBandLinkUserContext.Consumer>
                                    </Col>
                                </Row>

                                <Features band={1} bandItem={this.props.bandItem} />

                                { link["features"+this.props.bandItem]?.includes("7") || this.adaptativeModIsMandatory(link) ? 
                                <>
                                    <Row>
                                        <Col>
                                            <Form.Label>Minimum modulation</Form.Label>
                                            <Dropbox 
                                                uniqueKey="idMod" 
                                                displayInputKey="val"
                                                showStartedKey={link?.edit}
                                                startedKey={link["equipMod"+this.props.bandItem]?.idMod}
                                                values={(link["equipBandw"+this.props.bandItem] != null) ? link["equipBandw"+this.props.bandItem].modulations : []} 
                                                onChange={(newData) => this.onChangeMod(link, newData)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Label>Maximum modulation</Form.Label>
                                            <Dropbox 
                                                uniqueKey="idMod" 
                                                displayInputKey="val" 
                                                showStartedKey={link?.edit}
                                                startedKey={link["equipModMax"+this.props.bandItem]?.idMod}
                                                values={(link["equipBandw"+this.props.bandItem] != null && link["equipMod"+this.props.bandItem] != null) ? this.filterLessValue(link["equipMod"+this.props.bandItem].val, link["equipBandw"+this.props.bandItem].modulations) : []} 
                                                onChange={(newData) => this.onChangeModMax(link, newData)}
                                            />
                                        </Col>
                                    </Row>

                                </> : 
                                <Row>
                                    <Col>
                                        <Form.Label>Modulation</Form.Label>
                                        <Dropbox 
                                            uniqueKey="idMod" 
                                            displayInputKey="val"
                                            showStartedKey={link?.edit}
                                            startedKey={link["equipMod"+this.props.bandItem]?.idMod}
                                            values={(link["equipBandw"+this.props.bandItem] != null) ? link["equipBandw"+this.props.bandItem].modulations : []} 
                                            onChange={(newData) => this.onChangeMod(link, newData)}
                                        />
                                    </Col>
                                </Row>}
                                
                                <Row className={link["equipMod"+this.props.bandItem] == null ? "hide-input" : ""}>
                                    <Col>
                                        <Form.Label>TX power (dBm)</Form.Label>
                                        <ValueInput valueType="float" value={link["equipMod"+this.props.bandItem] != null && link["tx_power"+this.props.bandItem] == null ? link["equipMod"+this.props.bandItem].txPowerMax : link["tx_power"+this.props.bandItem]} 
                                        onChange={(data: any) => link.define("tx_power"+this.props.bandItem, data)}
                                        onBlur={(data: any, error: any) => {
                                            data = parseFloat(data);
                                            if(!(data >= link["equipMod"+this.props.bandItem].txPowerMin && data <= link["equipMod"+this.props.bandItem].txPowerMax)) {
                                                error(true);
                                            }
                                        }}></ValueInput>
                                        { link.equipMod != null ?
                                        <div className="form-text" style={{fontSize: ".75rem"}}>
                                            Minimum TX Power is {link["equipMod"+this.props.bandItem].txPowerMin}dBm / Maximum TX Power is {link["equipMod"+this.props.bandItem].txPowerMax}dBm
                                        </div>
                                        : null }
                                    </Col>
                                </Row>
                            </>
                        )}
                    </SingleBandLinkReferenceContext.Consumer>
                    </>
                )}
                </SingleBandLinkUserContext.Consumer>
                :
                <DualBandLinkUserContext.Consumer>
                {(link) => (
                    <>
                    <DualBandLinkReferenceContext.Consumer>
                        {(linkRef) => (
                            <>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Label>Frequency band (GHz)</Form.Label>
                                        <Dropbox 
                                            uniqueKey="idFreq" 
                                            displayInputKey="freq"
                                            showStartedKey={link?.edit}
                                            startedKey={link["equipFreq"+this.props.bandItem]?.idFreq}
                                            values={(linkRef.equipNorms != null && link["equipType"+this.props.bandItem] != null && link["equipType"+this.props.bandItem].frequences != null) ? link["equipType"+this.props.bandItem].frequences : []} 
                                            onChange={(newData) => EquipmentDetails.onChangeFreq(acc.token, link, newData, this.props.bandItem, this.props.bandItem == "" ? "2" : "")}
                                        />
                                    </Col>
                                    
                                    <Col xs={6}>
                                        <Form.Label>Channel bandwidth (MHz)</Form.Label>
                                        <Dropbox 
                                            uniqueKey="idChannelBdw" 
                                            displayInputKey="val"
                                            showStartedKey={link?.edit}
                                            startedKey={link["equipBandw"+this.props.bandItem]?.idChannelBdw}
                                            values={(linkRef.equipNorms != null && link["equipFreq"+this.props.bandItem] != null) ? link["equipFreq"+this.props.bandItem].bandwidths : []} 
                                            onChange={(newData) => EquipmentDetails.onChangeChannelBdw(acc.token, link, newData, this.props.bandItem)}
                                        />
                                    </Col>
                                    
                                </Row>

                                <Row>
                                    <Col xs={6}>
                                        <Form.Label>Configuration</Form.Label>
                                        <Dropbox 
                                            uniqueKey="idConf" 
                                            displayInputKey="name" 
                                            showStartedKey={link?.edit}
                                            startedKey={link["equipConf"+this.props.bandItem]?.idConf}
                                            values={(link["equipFreq"+this.props.bandItem] != null) ? link["equipFreq"+this.props.bandItem]?.configurations : []} 
                                            onChange={(newData) => EquipmentDetails.onChange(acc.token, link, newData, this.props.bandItem)}
                                        />
                                    </Col>
            
                                    <Col xs={6} style={{marginBottom: "0", marginTop: "auto"}} className='pb-1'>
                                        <DualBandLinkUserContext.Consumer>
                                            {(linkUser) => (
                                            linkUser["equipConf"+this.props.bandItem]?.features?.map((st: {idFeature: number, name: string, shortname: string, mandatory: boolean}, index: any) =>
                                                <>
                                                { st.idFeature == 4 ?
                                                    <Form.Check 
                                                        type="checkbox"
                                                        label={st.name}
                                                        checked={st.mandatory || linkUser["features"+this.props.bandItem]?.includes(st.idFeature.toString())} 
                                                        value={st.idFeature}
                                                        onChange={(e) => {
                                                            if(!st.mandatory) {
                                                                this.onChangeSD(linkUser, e)
                                                            }
                                                        }}
                                                        disabled={st.mandatory}
                                                    />
                                                : <></> }
                                                </>
                                                )
                                            )}
                                        </DualBandLinkUserContext.Consumer>
                                    </Col>
                                </Row>

                                <Features band={2} bandItem={this.props.bandItem} />

                                { link[this.getKeyValue("features")]?.includes("7") || this.adaptativeModIsMandatory(link) ? 
                                <>
                                    <Row>
                                        <Col>
                                            <Form.Label>Minimum modulation</Form.Label>
                                            <Dropbox 
                                                uniqueKey="idMod" 
                                                displayInputKey="val"
                                                showStartedKey={link?.edit}
                                                startedKey={link["equipMod"+this.props.bandItem]?.idMod}
                                                values={(link["equipBandw"+this.props.bandItem] != null) ? link["equipBandw"+this.props.bandItem].modulations : []} 
                                                onChange={(newData) => this.onChangeMod(link, newData)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Label>Maximum modulation</Form.Label>
                                            <Dropbox 
                                                uniqueKey="idMod" 
                                                displayInputKey="val" 
                                                showStartedKey={link?.edit}
                                                startedKey={link["equipModMax"+this.props.bandItem]?.idMod}
                                                values={(link["equipBandw"+this.props.bandItem] != null && link["equipMod"+this.props.bandItem] != null) ? this.filterLessValue(link["equipMod"+this.props.bandItem].val, link["equipBandw"+this.props.bandItem].modulations) : []} 
                                                onChange={(newData) => this.onChangeModMax(link, newData)}
                                            />
                                        </Col>
                                    </Row>

                                </> : 
                                <Row>
                                    <Col>
                                        <Form.Label>Modulation</Form.Label>
                                        <Dropbox 
                                            uniqueKey="idMod" 
                                            displayInputKey="val"
                                            showStartedKey={link?.edit}
                                            startedKey={link["equipMod"+this.props.bandItem]?.idMod}
                                            values={(link["equipBandw"+this.props.bandItem] != null) ? link["equipBandw"+this.props.bandItem].modulations : []} 
                                            onChange={(newData) => this.onChangeMod(link, newData)}
                                        />
                                    </Col>
                                </Row>}
                                
                                <Row className={link["equipMod"+this.props.bandItem] == null ? "hide-input" : ""}>
                                    <Col>
                                        <Form.Label>TX power (dBm)</Form.Label>
                                        <ValueInput valueType="float" value={link["equipMod"+this.props.bandItem] != null && link["tx_power"+this.props.bandItem] == null ? link["equipMod"+this.props.bandItem].txPowerMax : link["tx_power"+this.props.bandItem]} 
                                        onChange={(data: any) => link.define("tx_power"+this.props.bandItem, data)}
                                        onBlur={(data: any, error: any) => {
                                            data = parseFloat(data);
                                            if(!(data >= link["equipMod"+this.props.bandItem].txPowerMin && data <= link["equipMod"+this.props.bandItem].txPowerMax)) {
                                                error(true);
                                            }
                                        }}></ValueInput>
                                        { link["equipMod"+this.props.bandItem] != null ?
                                        <div className="form-text" style={{fontSize: ".75rem"}}>
                                            Minimum TX Power is {link["equipMod"+this.props.bandItem].txPowerMin}dBm / Maximum TX Power is {link["equipMod"+this.props.bandItem].txPowerMax}dBm
                                        </div>
                                        : null }
                                    </Col>
                                </Row>
                            </>
                        )}
                    </DualBandLinkReferenceContext.Consumer>
                    </>
                )}
                </DualBandLinkUserContext.Consumer>
                }
                </>
            )}
            </AccountContext.Consumer>
        );
    }

}